export default __webpack_public_path__ + "static/trade-gothic-ltstd-bdcn20-10d15a90f3a7a3a85dcb157cce5c95a1.woff2";